import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import Rules from "@/pages/Rules";
import SwingFAQ from "@/pages/SwingFAQ";
import { TERMS, FUNDED_TERMS } from "@/data/legal";
import { PRIVACY_POLICY, CLIENT_PRIVACY } from "@/data/policies";
import { Toaster } from "@/components/ui/sonner";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain bg-[#0D0E13] text-[#DBDFE8] min-h-screen" data-testid="app-root">
      <BrowserRouter>
        <HelmetProvider>
        <ScrollManager />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<LegalPage doc={TERMS} testId="terms-page" desc="The terms governing MyFXPocket evaluation and simulated trading programs, operated by FX-EDGE V LTD: fees, refunds, forbidden trading and more." />} />
          <Route path="/funded-terms" element={<LegalPage doc={FUNDED_TERMS} testId="funded-terms-page" desc="Full terms for MyFXPocket funded accounts: rewards, payouts, KYC, trailing drawdown, the 25% consistency rule and Schedule 1 parameters." />} />
          <Route path="/privacy" element={<LegalPage doc={PRIVACY_POLICY} testId="privacy-page" desc="How MyFXPocket and FX-EDGE V Ltd collect, use and protect your personal data: cookies, your rights, processing periods and data transfers." />} />
          <Route path="/client-privacy" element={<LegalPage doc={CLIENT_PRIVACY} testId="client-privacy-page" desc="Privacy notice for MyFXPocket clients: data controller details, legal bases, storage periods, transfers and your data protection rights." />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/swing-faq" element={<SwingFAQ />} />
        </Routes>
        <Footer />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#20222D",
              border: "1px solid rgba(255,215,0,0.3)",
              color: "#FFFFFF",
            },
          }}
        />
        </HelmetProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
